module.exports = __webpack_public_path__ + "static/media/Rectangle 13.86e6246e.png";